<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2  mb-8">
      <v-row>
        <v-col cols='12' md='8'>
          <v-card>
            <v-form
              @submit.prevent="save()"
              ref="form"
              lazy-validation
            >
              <v-card-text>
                <v-row>
                  <div class="dropzone-hero-img ma-6"
                    @dragover.prevent
                    @drop.prevent="onFileChange('heroImg', $event)"
                    @click="$refs.heroImageFile.click()"
                  >
                    <img v-if="heroImg" :src="heroImg"/>
                    <div v-else class="text-center">
                      <div class="text-subtitle-1 mx-2">Drop file here or click to upload your banner image</div>
                      <div class="caption font-weight-medium">Maximum upload file size: 5MB</div>
                    </div>

                    <v-btn
                      v-if="heroImg"
                      @click.stop="removeHeroImage()"
                      small
                      icon
                      class="remove-image-btn"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <input type="file" ref="heroImageFile" style="display: none" @change="onFileChange('heroImg', $event)">
                  </div>

                  <div class="dropzone-logo-img px-8"
                    @dragover.prevent
                    @drop.prevent="onFileChange('logoImg', $event)"
                    @click="$refs.logoImgFile.click()"
                  >
                    <img v-if="logoImg" :src="logoImg"/>
                    <div v-else class="text-center">
                      <div class="text-subtitle-1">Drop file here or click to upload your logo image</div>
                      <div class="caption font-weight-medium">Maximum upload file size: 5MB</div>
                    </div>

                    <v-btn
                      v-if="logoImg"
                      @click.stop="removeLogoImage()"
                      small
                      icon
                      class="remove-image-btn"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>

                    <input type="file" ref="logoImgFile" style="display: none" @change="onFileChange('logoImg', $event)">
                  </div>
                </v-row>

                <v-row class="mt-8">
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="award.name"
                      label="Name"
                      class="mx-2"
                      autofocus
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="award.additional_info"
                      label="Additional Information"
                      class="mx-2"
                      filled
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-textarea
                      v-model="award.notes"
                      label="About"
                      rows="4"
                      class="mx-2"
                      filled
                    ></v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.establishment_year"
                      :items="years"
                      label="Year of Establishment"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.discontinued_year"
                      :items="years"
                      label="Year of Discontinue"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.country_id"
                      :items="countries"
                      item-text="name"
                      item-value="id"
                      label="Country"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.frequency"
                      :items="frequencies"
                      label="Frequency"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.geofocuses"
                      :items="geofocuses"
                      item-text="name"
                      item-value="id"
                      dense
                      label="Geographical Focus"
                      multiple
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-checkbox
                      v-model="award.ceased_to_exist"
                      label="Ceased to Exist"
                      class="mx-2"
                    ></v-checkbox>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="award.website"
                      label="Website URL"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.themes"
                      :items="themes"
                      item-text="name"
                      item-value="id"
                      label="Themes"
                      class="mx-2"
                      filled
                      multiple
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="award.nomination"
                      :items="nominations"
                      label="Public Nominations"
                      class="mx-2"
                      filled
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="award.prize_money"
                      label="Prize Money"
                      class="mx-2"
                      prepend-inner-icon="mdi-currency-eur"
                      filled
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-menu
                      ref="menuDeadline"
                      v-model="menuDeadline"
                      :close-on-content-click="false"
                      :return-value.sync="award.deadline"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="award.deadline"
                          label="Deadline"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable
                          class="mx-2"
                          filled
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="award.deadline" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menuDeadline = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menuDeadline.save(award.deadline)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-select
                      v-model="awardYears"
                      :items="years"
                      label="Years Award Given"
                      class="mx-2"
                      prepend-inner-icon="mdi-calendar-range"
                      filled
                      multiple
                      small-chips
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-menu
                      ref="menuCeremonyDates"
                      v-model="menuCeremonyDates"
                      :close-on-content-click="false"
                      :return-value.sync="ceremonyDates"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-combobox
                          v-model="ceremonyDatesFormatted"
                          multiple
                          small-chips
                          label="Upcoming Ceremony Dates"
                          prepend-inner-icon="mdi-calendar-month"
                          v-bind="attrs"
                          v-on="on"
                          class="mx-2"
                          filled
                        >
                        <template v-slot:append v-if="ceremonyDates.length">
                          <v-btn small icon @click="ceremonyDates = []">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                        </v-combobox>
                      </template>
                      <v-date-picker v-model="ceremonyDates" multiple no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menuCeremonyDates = false">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menuCeremonyDates.save(ceremonyDates)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="award.email"
                      label="Administrative Email"
                      class="mx-2"
                      filled
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer/>
                <v-btn
                  color="accent"
                  depressed
                  class="mx-4 mb-6"
                  type="submit"
                >
                  Save
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>

        <v-col cols='12' md='4'>
          <v-card>
            <v-card-text>
              <v-list>
                <div class="text-h6 primary-title primary--text mb-2">Laureates</div>
                <template v-for="item in sortedAwardLaureates">
                  <v-hover
                    v-slot:default="{ hover }"
                    :key="item.id"
                  >
                    <v-list-item
                      two-line
                      link
                      exact
                      :to="{ name: 'laureates.edit', params: { id: item.id } }"
                    >
                      <v-list-item-action class="list-avatar d-flex justify-center">
                        <img
                          v-if="item.image"
                          :src="`${baseURL}/img/laureates/64/${item.image}`"
                        >
                        <v-avatar v-else color="blue-grey lighten-5">
                          <span class="blue-grey--text text--darken-1">
                            {{ item | fullName | capitalizeName }}
                          </span>
                        </v-avatar>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>{{ item | fullName }}</v-list-item-title>
                        <v-list-item-subtitle>{{ item.pivot.year }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-icon>
                        <v-btn
                          v-show="hover"
                          @click.prevent="callConfirmUnlinkLaureateDialog(item)"
                          small
                          icon
                          class="remove-image-btn"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-hover>
                </template>
              </v-list>
              <v-btn
                @click="linkLaureateDialog = true"
                absolute
                small
                dark
                fab
                bottom
                right
                color="primary"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Link Laureate Dialog-->
      <link-laureate-dialog
        :dialog="linkLaureateDialog"
        :laureates="laureates"
        :years="years"
        @close="closeLinkLaureateDialog"
        @link="linkLaureate"
        ref="linkLaureateDialog"
      ></link-laureate-dialog>

      <!-- Unlink Laureate Dialog-->
      <confirm-unlink-laureate-dialog
        ref="confirmUnlinkLaureateDialog"
        :laureate="laureateToUnlink"
      ></confirm-unlink-laureate-dialog>

    </div>
  </div>
</template>

<script>
import ConfirmUnlinkLaureateDialog from '@/components/awards/ConfirmUnlinkLaureateDialog.vue'
import LinkLaureateDialog from '@/components/awards/LinkLaureateDialog.vue'
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Create',

  mixins: [messagesMixin],

  components: {
    ConfirmUnlinkLaureateDialog,
    LinkLaureateDialog,
    Loader
  },

  data () {
    return {
      award: {
        additional_info: '',
        award_years: [],
        ceased_to_exist: false,
        ceremony_dates: [],
        country_id: null,
        deadline: null,
        discontinued_year: '',
        email: '',
        establishment_year: '',
        geofocuses: [],
        image: '',
        image_hero: '',
        laureates: [],
        name: '',
        nomination: '',
        prize_money: null,
        themes: []
      },
      awardYears: [],
      ceremonyDates: [],
      countries: [],
      frequencies: ['Annual', 'Bi-Annual', 'Occasional', 'Unknown'],
      geofocuses: [],
      heroImg: '',
      laureates: [],
      laureateToUnlink: {},
      logoImg: '',
      linkLaureateDialog: false,
      menuCeremonyDates: false,
      menuDeadline: false,
      nominations: ['Yes', 'No', 'Unknown'],
      pageLoaded: false,
      themes: []
    }
  },

  mounted () {
    Promise.all([
      this.getCountries(),
      this.getGeofocuses(),
      this.getLaureates(),
      this.getThemes()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  computed: {
    ceremonyDatesFormatted () {
      return this.ceremonyDates.map(item => this.moment(item).format('L'))
    },

    sortedAwardLaureates () {
      const laureates = this.award.laureates
      return laureates.sort((a, b) => a.pivot.year - b.pivot.year)
    },

    years () {
      const years = []

      for (var i = this.moment().add(5, 'year').format('YYYY'); i >= 1900; i--) {
        years.push(i.toString())
      }

      return years
    }
  },

  methods: {
    callConfirmUnlinkLaureateDialog (item) {
      this.laureateToUnlink = item

      this.$refs.confirmUnlinkLaureateDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.award.laureates = this.award.laureates.filter(el => el.id !== item.id)
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    closeLinkLaureateDialog () {
      this.linkLaureateDialog = false
    },

    getCountries () {
      return this.$http.get('/countries')
        .then(({ data }) => {
          this.countries = data.countries
        })
        .catch(error => {
          console.log(error)
        })
    },

    getGeofocuses () {
      return this.$http.get('/geofocuses')
        .then(({ data }) => {
          this.geofocuses = data.geofocuses
        })
        .catch(error => {
          console.log(error)
        })
    },

    getLaureates () {
      return this.$http.get('/laureates')
        .then(({ data }) => {
          this.laureates = data.laureates
        })
        .catch(error => {
          console.log(error)
        })
    },

    getThemes () {
      return this.$http.get('/themes')
        .then(({ data }) => {
          this.themes = data.themes
        })
        .catch(error => {
          console.log(error)
        })
    },

    linkLaureate (item) {
      this.award.laureates.push(item)

      this.linkLaureateDialog = false
    },

    onFileChange (img, e) {
      const files = e.target.files || e.dataTransfer.files

      if (!files[0].name.match(/.(jpg|jpeg|png)$/i)) {
        this.showCustomErrorMessage('Ooops! You can upload jpg, jpeg, png extensions files only', 3000)
        return
      }

      if (files[0].size > 5242880) {
        this.showCustomErrorMessage('Ooops! Maximum upload file size: 5MB', 3000)
        return
      }

      if (!files.length) return

      const file = files[0]

      const reader = new FileReader()
      reader.onload = f => {
        // f.target.result contains the base64 encoding of the image
        this[img] = f.target.result
      }
      reader.readAsDataURL(file)
    },

    removeHeroImage () {
      this.heroImg = ''
    },

    removeLogoImage () {
      this.logoImg = ''
    },

    save () {
      this.award.award_years = JSON.stringify(this.awardYears)
      this.award.ceremony_dates = JSON.stringify(this.ceremonyDates)
      this.award.image_hero = this.heroImg
      this.award.image = this.logoImg

      this.$http.post('/awards', {
        award: this.award
      })
        .then(({ data }) => {
          this.$router.push({ name: 'awards.index' })

          this.showSuccessMessage('Award was saved successfully!')
        })
        .catch(error => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    unlinkLaureate (item) {
      this.award.laureates = this.award.laureates.filter(el => el.id !== item.id)
    }
  }
}
</script>

<style scoped>
  .dropzone-hero-img {
    width: 100%;
    height: 200px;
    position: relative;
    border: 2px dashed rgba(0,0,0,0.12);
    color: rgba(0, 0, 0, 0.6);
    display: grid;
    place-items: center;
  }

  .dropzone-logo-img {
    margin: auto;
    margin-top: -70px;
    max-width: 320px;
    height: 160px;
    position: relative;
    border: 2px dashed rgba(0,0,0,0.12);
    background: #fff;
    color: rgba(0, 0, 0, 0.6);
    display: grid;
    place-items: center;
  }

  .dropzone-logo-img:hover,
  .dropzone-hero-img:hover {
    border: 2px dashed rgba(23,122,152,0.4);;
    background-color: #E8F2F4;
    cursor: pointer;
    color: #177a97;
  }

  .dropzone-hero-img img {
    display: block;
    margin: auto;
    max-height: 196px !important;
    max-width: 100% !important;
  }

  .dropzone-logo-img img {
    display: block;
    margin: auto;
    max-height: 156px !important;
    max-width: 100% !important;
  }

  .remove-image-btn {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .list-avatar {
    width: 24px;
  }

  .list-avatar img {
    max-height: 48px;
    max-width: 48px;
    vertical-align: middle;
  }
</style>
